<template>
	<div class="mainWrapper po">
		<h1>Product Transfer Detail</h1>
		<div class="po-details" v-if="transfer">
			<div class="first-row">
				<div class="details">
					<span>TRANSFER CODE</span> <br />
					{{ transfer.code }}
				</div>
				<div class="details">
					<span>SHOP</span> <br />
					{{ transfer.shop.name }}
				</div>
				<div class="details">
					<span>BRAND</span> <br />
					{{ transfer.brand.name }}
				</div>
				<div class="details">
					<span>TRANSFER DATE</span> <br />
					{{ convertTime(transfer.transfer_date) }}
				</div>
				<div class="details">
					<span>CREATED</span> <br />
					{{ convertTime(transfer.createdAt) }}
				</div>
			</div>

			<div class="list">
				<div class="poItemList header">
					<div>BD CODE</div>
					<div>BARCODE</div>
					<div>PRODUCT NAME</div>
					<div>REQUESTED QUANTITY</div>
					<div>REMARK</div>
				</div>

				<div v-for="(item, index) of transfer.product" v-bind:key="index" class="poItemList">
					<div>{{ item.product.bd_code }}</div>
					<div>{{ item.product.barcode }}</div>
					<div>{{ item.product.name }}</div>
					<div>{{ item.stock }}</div>
					<div>{{ item.description }}</div>
				</div>
			</div>

			<div class="po-detail-buttons-wrapper">
				<div class="align-left">
					<b-button type="is-dark" icon-left="arrow-left" @click="back()">BACK</b-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'WarehouseTransferDetail',
	data: function() {
		return {
			transferID: this.$route.params.id, //id from get url
			transfer: null // PO details
		}
	},
	mounted: async function() {
		var data = {
			id: this.transferID,
			populate: ['author', 'shop', 'brand', 'product.product']
		}

		const apiGetTransfer = await this.$api.getProductTransfer({ data })

		this.transfer = apiGetTransfer.data.list[0]

		console.log(apiGetTransfer)
	},
	methods: {
		createPI: function() {
			// this.$router.push("/pi/view/" + this.poId);
			const id = this.poId
			this.$router.push({ name: 'createPi', params: { id } })
		},
		back: function() {
			this.$router.go(-1)
		},
		// Convert time
		convertTime: function(time) {
			if (time) {
				return this.$moment(time).format('DD/MM/YY')
			} else {
				return ''
			}
		}
	}
}
</script>

<style scoped>
@import '../styles/PO.css';
</style>
